import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import DutyPeriodList from "./DutyPeriodList";
import DutyPeriodForm from "./DutyPeriodForm";
import { LIST, CREATE, UPDATE } from "../../../queries/duty-period.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";
import DutyPeriodUpdateForm from "./DutyPeriodUpdateForm.jsx";

function DutyPeriod({ match, location }) {
	// local state
	const [newDutyPeriod, setNewDutyPeriod] = useState(false);
	const [uDutyPeriod, setUDutyPeriod] = useState(null);

	const { LogOut, IsAuthenticationError } = auth.authProvider;
	// query;
	const { loading, error, data } = useQuery(LIST);
	// New
	const [
		PostCreateFunc,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(CREATE, {
		update(caches, cb) {
			const { GetRotaDutyPeroids } = caches.readQuery({
				query: LIST
			});
			GetRotaDutyPeroids.docs.unshift(cb.data.CreateRotaDutyPeroid.doc);
			caches.writeQuery({
				query: LIST,
				data: { GetRotaDutyPeroids }
			});
		}
	});

	const [
		updateFunc,
		{ loading: iLoading, error: iError, data: iData }
	] = useMutation(UPDATE);

	/**
	 * A function that scrolls the page to top
	 */
	function scrollTop() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}
	const title = "Rota Duty Period";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];
	if (error && IsAuthenticationError(error.message)) {
		LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />
			<div className="row justify-content-center">
				{newDutyPeriod && !uDutyPeriod && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNewDutyPeriod(false);
											scrollTop();
											setUDutyPeriod(null);
										}}
										title="Back"
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
									>
										<i className="material-icons">keyboard_backspace</i>
									</button>
									New Duty Period
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<AlertMessage
									message={cData && cData.CreateRotaDutyPeroid.message}
								/>

								<DutyPeriodForm
									onCancel={() => {
										setNewDutyPeriod(false);
										scrollTop();
										setUDutyPeriod(null);
									}}
									onSubmit={async name => {
										await PostCreateFunc({
											variables: { name }
										});
										setTimeout(() => {
											setNewDutyPeriod(false);
											scrollTop();
											setUDutyPeriod(null);
										}, 500);
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{!newDutyPeriod && !uDutyPeriod && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Duty Period List</header>
								<div className="tools">
									<button
										type="button"
										onClick={() => {
											setNewDutyPeriod(true);
											scrollTop();
											setUDutyPeriod(null);
										}}
										className="mdl-button mdl-button--icon btn-success"
									>
										<i className="material-icons">add</i>
									</button>
								</div>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={loading} />
								<AlertMessage message={error && error.message} failed={true} />

								{!loading && (
									<DutyPeriodList
										items={data && data.GetRotaDutyPeroids.docs}
										onEdit={item => {
											setNewDutyPeriod(false);
											scrollTop();
											setUDutyPeriod(item);
										}}
									/>
								)}
							</div>
						</div>
					</div>
				)}

				{!newDutyPeriod && uDutyPeriod && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNewDutyPeriod(false);
											setUDutyPeriod(null);
											scrollTop();
										}}
										title="Back"
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
									>
										<i className="material-icons">keyboard_backspace</i>
									</button>
									Update Duty Period
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={iLoading} />
								<AlertMessage
									message={iError && iError.message}
									failed={true}
								/>
								<AlertMessage
									message={iData && iData.UpdateRotaDutyPeroid.message}
								/>
								<DutyPeriodUpdateForm
									onCancel={() => {
										setNewDutyPeriod(false);
										setUDutyPeriod(null);
										scrollTop();
									}}
									onSubmit={async name => {
										await updateFunc({
											variables: { id: uDutyPeriod.id, name }
										});
										setTimeout(() => {
											setNewDutyPeriod(false);
											scrollTop();
											setUDutyPeriod(null);
										}, 500);
									}}
									currentValue={uDutyPeriod.name}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default DutyPeriod;
